module.exports = __webpack_public_path__ + "img/00052.ec2a1e2a.webp";